import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPencilLine: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconPencilLine"><Path d="M19.6164 2.72699C18.6471 1.75767 17.0755 1.75767 16.1062 2.72699L2.72699 16.1062C2.26151 16.5717 2 17.203 2 17.8613V22H6.13872C6.79701 22 7.42834 21.7385 7.89383 21.273L21.273 7.89383C22.2423 6.92451 22.2423 5.35293 21.273 4.3836L19.6164 2.72699Z" fill="currentColor"/><Path d="M11.5 21C11.2239 21 11 21.2239 11 21.5C11 21.7761 11.2239 22 11.5 22H21.5C21.7761 22 22 21.7761 22 21.5C22 21.2239 21.7761 21 21.5 21H11.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPencilLine;
